import React from 'react'

function Unauthorized() {
    return (
        <div className='text-center mt-5'>
            404 - Page Not Found. You are not authorized.
        </div>
    )
}

export default Unauthorized
